import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TwoPathSplit from "./components/TwoPathSplit";
import EmergingBrands from "./components/EmergingBrands";
import OwnBrand from "./components/OwnBrand";
import WhatWePack from "./components/WhatWePack";
import HowItWorks from "./components/HowItWorks";
import PlantCapacity from "./components/PlantCapacity";
import CaseStudy from "./components/CaseStudy";
import Faq from "./components/Faq";
import ProposalForm from "./components/ProposalForm";
import Footer from "./components/Footer";

export default function PrivateLabel() {
  useEffect(() => {
    document.title =
      "Organic Private Label & Co-Packing from Colombia | Mesa Baja";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Certified organic private label and co-packing of whole cane sugar and cocoa powder from Colombia. Ecocert USDA and EU Organic, HACCP, low minimums. Request a proposal."
      );
    }
  }, []);

  return (
    <main className="min-h-screen bg-cream">
      <Header />
      <Hero />
      <TwoPathSplit />
      <EmergingBrands />
      <OwnBrand />
      <WhatWePack />
      <HowItWorks />
      <PlantCapacity />
      <CaseStudy />
      <Faq />
      <ProposalForm />
      <Footer />
    </main>
  );
}